// סוגי קשרי משפחה בין לקוחות. כל סוג + הסוג ההופכי שלו (לכתיבה דו-כיוונית).
export const REL_TYPES = {
  spouse:  { label: "בן/בת זוג",  reciprocal: "spouse"  },
  parent:  { label: "הורה",       reciprocal: "child"   },
  child:   { label: "ילד/ה",      reciprocal: "parent"  },
  sibling: { label: "אח/אחות",    reciprocal: "sibling" },
  other:   { label: "קרוב משפחה", reciprocal: "other"   },
};

export function reciprocalOf(type) {
  return REL_TYPES[type]?.reciprocal || "other";
}
